import GLightbox from 'glightbox';
import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {

  connect() {
    const lightbox = GLightbox({});
  }
}